export default __webpack_public_path__ + "d26201c.png";